<template>
  <v-container class="pa-1">
    <v-layout>
      <v-flex xs12 mx-auto>
        <v-card flat v-if="lAction === 'view'" class="pa-2">
          <!-- stats -->
          <v-card flat>
            <v-card-text class="px-0 pt-0 pb-2 text-xs-center subheading">
              <v-layout row wrap>
                <v-flex :class="!config.IS_ADMIN ? 'xs7' : 'xs3'">
                  Blocks<br /><br v-if="!$vuetify.breakpoint.smAndUp" />
                  <v-progress-circular color="primary"
                  :value="100"
                  :size="60" :width="8">
                  {{ blocks.length }}
                </v-progress-circular>
              </v-flex>
              <v-flex xs3>
                Units<br /><br v-if="!$vuetify.breakpoint.smAndUp" />
                <v-progress-circular color="primary"
                :value="100"
                :size="60" :width="8">
                {{ totUnits }}
              </v-progress-circular>
            </v-flex>
            <v-flex xs3 v-if="config.IS_ADMIN">
              Users<br /><br v-if="!$vuetify.breakpoint.smAndUp" />
              <v-progress-circular color="primary"
              :value="100 - unitsWithNOUsers.length/totUnits*100"
              :size="60" :width="8">
              {{ totUsers }}
            </v-progress-circular>
            <v-btn @click="filterList('U')" small icon :class="'ma-0 ' + (filterBy === 'U' ? 'primary' : 'grey lighten-4')"><v-icon small>filter_list</v-icon></v-btn>
          </v-flex>
          <v-flex xs3 v-if="config.IS_ADMIN">
            <span>Units with no user</span><br />
            <v-progress-circular color="error"
            :value="unitsWithNOUsers.length/totUnits*100"
            :size="60" :width="8">
            {{ unitsWithNOUsers.length }}
          </v-progress-circular>
          <v-btn @click="filterList('OU')" small icon :class="'ma-0 ' + (filterBy === 'OU' ? 'primary' : 'grey lighten-4')"><v-icon small>filter_list</v-icon></v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-divider></v-divider>
  </v-card>
  <!-- list of units -->
  <v-card flat>
    <v-card-title class="pt-2">
      <v-layout row wrap>
        <v-flex xs6>
          <v-text-field
          class="pa-0 mt-1"
          append-icon="search"
          :placeholder="$vuetify.breakpoint.smAndUp?'Search by name, unit no, etc.':'Search'"
          single-line
          hide-details
          v-model="search"
          ></v-text-field>
        </v-flex>
        <v-flex xs6 v-if="config.IS_ADMIN">
          <v-download-as
          :headers="unitHeadSm"
          :items="residents.filter(rec => (!filterBy || (filterBy === 'U' && rec.user_id) || (filterBy === 'OU' && rec.is_orphan_unit) || (filterBy === 'NU' && !rec.user_id && !rec.is_orphan_unit)))"
          title="Resident directory"
          :fontsize="9"
          :landscape="true"
          ></v-download-as>
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text class="pa-0">
      <div v-if="residents.filter(rec => !rec.user_id && !rec.is_orphan_unit).length" class="text-xs-right caption warning--text">
        * Not Integra user, but someone from that unit using app
        <v-btn @click="filterList('NU')" small icon :class="'ma-0 ' + (filterBy === 'NU' ? 'info' : 'grey lighten-4')"><v-icon small>filter_list</v-icon></v-btn>
      </div>
      <v-data-table
      :headers="$vuetify.breakpoint.smAndUp?unitHeadSm:unitHead"
      :items="residents.filter(rec => (!filterBy || (filterBy === 'U' && rec.user_id) || (filterBy === 'OU' && rec.is_orphan_unit) || (filterBy === 'NU' && !rec.user_id && !rec.is_orphan_unit)))"
      class="elevation-3"
      disable-initial-sort
      :rows-per-page-items = "[10,25,50,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
      :pagination.sync="pagination"
      :search="search"
      >
      <template slot="items" slot-scope="props">
        <tr @click="showUnit(props.item)" :class="props.item.is_orphan_unit ? 'error--text' : props.item.user_id ? '' : 'warning--text'">
          <td>{{ props.item.block_and_unit }}</td>
          <td>{{ props.item.cust_name }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.ownership }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.int_extn }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_phone_view }}</td>
          <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_email_view }}</td>
        </tr>
      </template>
    </v-data-table>
  </v-card-text>
</v-card>
</v-card>

<!-- dialog update unit details -->
<v-dialog v-model="isViewed" max-width="400px">
  <v-card flat>
    <v-card-title class="pa-0 grey lighten-4">
      <v-spacer></v-spacer>
      <v-btn icon small @click="isViewed=false"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pa-0">
      <v-card flat>
        <v-card-text class="px-3 py-0">
          <div class="text-xs-center pb-2">
            <div class="headline pt-2">{{lResident.cust_name}}</div>
            <div class="subheading">{{lResident.block_nm + ' ' + lResident.unit_no}}</div>
            <div class="caption grey--text">{{lResident.ownership + (lResident.user_id?' & Uniservice App user':'')}}</div>
            <v-avatar :size="120" class="grey lighten-4 ma-2">
              <img v-if="lResident.avatar_url" :src="config.STATIC_FILES_DIR + lResident.avatar_url">
              <v-icon v-else color="grey" size="110px">person</v-icon>
            </v-avatar>
          </div>
          <v-container class="pa-0">
            <v-layout wrap>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">Intercom</span>
              </v-flex>
              <v-flex xs8>
                <span>{{lResident.int_extn}}</span>
              </v-flex>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">Mobile</span>
              </v-flex>
              <v-flex xs7>
                <span v-if="config.IS_USER_EMPOWERED">{{lResident.contact_phone}}</span>
                <span v-else>{{lResident.contact_phone_view}}</span>
              </v-flex>
              <v-flex xs1>
                <v-btn v-if="false" :disabled="lResident.hide_contact" icon small class="ma-0"><v-icon small>content_copy</v-icon></v-btn>
              </v-flex>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">E-mail</span>
              </v-flex>
              <v-flex xs7>
                <span v-if="config.IS_USER_EMPOWERED">{{lResident.contact_email}}</span>
                <span v-else>{{lResident.contact_email_view}}</span>
              </v-flex>
              <v-flex xs1>
                <v-btn v-if="false" :disabled="lResident.hide_contact" icon small class="ma-0"><v-icon small>content_copy</v-icon></v-btn>
              </v-flex>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">Emergency</span>
              </v-flex>
              <v-flex xs7>
                <span>{{lResident.emergency_phone}}</span>
              </v-flex>
              <v-flex xs1>
                <v-btn v-if="false" icon small class="ma-0"><v-icon small>content_copy</v-icon></v-btn>
              </v-flex>

              <v-flex xs12 class="mb-2">
                <v-divider></v-divider>
              </v-flex>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">Blood Group</span>
              </v-flex>
              <v-flex xs8>
                <span>{{lResident.blood_group}}</span>
              </v-flex>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">Occupation</span>
              </v-flex>
              <v-flex xs8>
                <span>{{lResident.occupation}}</span>
              </v-flex>
              <v-flex xs4 class="mb-2">
                <span class="grey--text">Hobbies</span>
              </v-flex>
              <v-flex xs8>
                <span>{{lResident.hobbies}}</span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-card-text>
    <v-divider></v-divider v-if="config.IS_ADMIN">
      <v-card-actions v-if="config.IS_ADMIN">
        <v-spacer></v-spacer>
        <v-btn flat :disabled="lResident.user_id !== null"  @click.native="deleteResident()">Delete</v-btn>
        <v-btn flat @click.native="prepareUpdate(lResident)">Update</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-container v-show="lAction === 'create' || lAction === 'update'" class="pa-0" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-form ref="lForm" @submit.prevent="saveChanges()">
          <v-card flat>
            <v-flex xs12 sm9 mx-auto>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    label="Name"
                    v-model="lResident.cust_name"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-select
                    label="Gender"
                    :items="['Male', 'Female']"
                    v-model="lResident.gender"
                    :rules="[rules.required]"
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-combobox
                    v-model="lResident.block_nm"
                    label="Block"
                    :items="blockList"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="25"
                    @input="findBlockId()"
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs6>
                    <v-combobox
                    label="Unit no."
                    v-model="lResident.unit_no"
                    :rules="[rules.required]"
                    :items="unitList"
                    hide-details
                    maxlength="10"
                    @input="findUnitId()"
                    ></v-combobox>
                  </v-flex>
                  <v-flex xs12>
                    <v-radio-group :row="$vuetify.breakpoint.smAndUp" class="pt-0" v-model="lResident.ownership" mandatory hide-details>
                      <v-radio v-for="(curRole, ridx) in resRolesList" :key="ridx"
                      :label="curRole.role_name"
                      :value="curRole.role_name"
                      ></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex xs5 sm3>
                    <v-checkbox
                    :label="(config.COMM_COUNTRY_CODE === 'MY' ? 'JMB/' : 'RWA/') + 'MC Member'"
                    v-model="lResident.is_mc_member"
                    hide-details
                    ></v-checkbox>
                  </v-flex>
                  <v-flex xs7 sm9 v-if="lResident.is_mc_member">
                    <v-select class="pa-0" v-model="lResident.role_id"
                    placeholder="Role"
                    :items="mcRolesList"
                    item-text = "role_name"
                    item-value = "role_id"
                    :rules="[rules.required]"
                    hide-details
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 class="mt-3">
                    <span class="primary--text">Contact Information</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <vue-tel-input-vuetify
                    ref="refMob"
                    v-model="mobileNo"
                    label="Mobile number"
                    @keydown.native="ignoreBackspace"
                    @input="keepCursor"
                    :rules="[rules.required]"
                    :input-options="{showDialCode: true}"
                    @validate="validateMob"
                    maxlength="15"
                    />
                  </v-flex>

                  <v-flex xs12 sm6>
                    <v-text-field
                    label="E-mail"
                    v-model="lResident.contact_email"
                    :rules="[rules.required]"
                    hide-details
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="mt-3">
                    <span class="primary--text">Other Information (optional)</span>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="Intercom no."
                    v-model="lResident.int_extn"
                    hide-details
                    maxlength="10"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="Emergency phone"
                    v-model="lResident.emergency_phone"
                    hide-details
                    maxlength="15"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="Blood group"
                    v-model="lResident.blood_group"
                    hide-details
                    maxlength="10"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="Occupation"
                    v-model="lResident.occupation"
                    hide-details
                    maxlength="15"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                    label="Hobbies"
                    v-model="lResident.hobbies"
                    maxlength="50"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <span class="primary--text">Address</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                    label="Address"
                    v-model="lResident.address"
                    hide-details
                    maxlength="150"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="City"
                    v-model="lResident.city"
                    hide-details
                    maxlength="25"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="PIN Code"
                    v-model="lResident.pin_code"
                    hide-details
                    maxlength="10"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    label="State"
                    v-model="lResident.state"
                    maxlength="25"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <span class="primary--text">Tax Information</span>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                    label="GST Identification No."
                    v-model="lResident.gst_no"
                    hide-details
                    maxlength="15"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click.native="cancelChanges">Cancel</v-btn>
                <v-btn type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
              </v-card-actions>
            </v-flex>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>

  <v-container v-if="lAction === 'upload'" class="pa-0" grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <v-card-text class="subheading">
            <v-layout row wrap>
              <v-flex xs12>
                <div class="my-3 text-xs-center primary--text title"><i>Upload residents in just 4 easy steps</i></div>
              </v-flex>
              <v-flex xs12>
                <v-chip small disabled outline class="primary--text">Step 1</v-chip>
                <span>Download template <span v-if="$vuetify.breakpoint.smAndUp">by clicking on download button</span></span>
                <span style="float:right">
                  <form method="get" action="../static/files/Smartility_Resident_Directory.xlsx">
                    <v-btn type="submit" class="mt-0 mb-0" small><v-icon>file_download</v-icon></v-btn>
                  </form>
                </span>
              </v-flex>
              <v-flex xs12>
                <v-chip small disabled outline class="primary--text">Step 2</v-chip>
                <span>Fill-in details as guided in template</span>
              </v-flex>
              <v-flex xs12>
                <v-chip small disabled outline class="primary--text">Step 3</v-chip>
                <span>Save the Excel file as CSV <span class="caption">(Comma delimited)</span><br />
                <span class="caption grey--text pl-4 ml-4">
                  <span class="ml-4">Choose OK/Yes when prompted while saving</span>
                </span>
              </span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 4</v-chip>
              <span>Upload the CSV file <span v-if="$vuetify.breakpoint.smAndUp">by clicking on upload button</span></span>
              <span style="float:right;"><v-btn small class="mt-0 mb-0 accent" @click.native="promptUpload"><v-icon>file_upload</v-icon></v-btn></span>
              <input style="display:none" ref="ipFile" type="file" accept=".csv" @change="validateFile()"/>
            </v-flex>
            <v-flex xs12>
              <div class="my-3 text-xs-center primary--text title"><i>Integra takes care of rest</i></div>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 5</v-chip>
              <span>Validate your information</span>
            </v-flex>
            <v-flex xs12>
              <v-chip small disabled outline class="primary--text">Step 6</v-chip>
              <span>Create resident records</span>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="cancelChanges" class="mx-0"><v-icon>chevron_left</v-icon> Back</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</v-flex>
</v-layout>
<!-- validate and upload -->
<v-layout>
  <v-flex xs12>
    <v-container v-if="lAction === 'validate'" class="pa-0" grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card flat>
            <v-card-title class="title pb-0">
              Upload Resident Directory
            </v-card-title>
            <v-card-text class="text-xs-center pl-2 pr-2">
              <v-layout row wrap>
                <v-flex xs12 md9 mx-auto>
                  <v-layout row wrap>
                    <v-flex xs12 class="info--text mb-2">
                      <span v-if="validateInProgress">Loading and validating the file...</span>
                      <span v-if="validFile && !validateInProgress">File validation is successfull <v-icon class="success--text">check</v-icon></span>
                      <span v-if="!validFile">File validation is failed <v-icon class="error--text">close</v-icon></span>
                      <span v-if="!validFile && headerIssue" class="error--text"><br />Invalid column headers, please ensure names and count are matching as per the template</span>
                      <span v-if="!validFile && !headerIssue" class="error--text"><br />One or more invalid records, review the table below.<br/>Click on the errored row to know more info.</span>
                      <span v-if="!totFail && !loadInProgress">Resident directory creation was successfull<v-icon class="success--text">check</v-icon></span>
                      <span v-if="!totLoaded && totFail && !loadInProgress"><br />Resident directory creation failed<v-icon class="error--text">close</v-icon></span>
                      <span v-if="totLoaded && totFail && !loadInProgress"><br />Resident directory creation partially failed<v-icon class="warning--text">close</v-icon></span>
                      <span v-if="totFail && !loadInProgress" class="error--text"><br />One or more failed records, review the table below.<br/>Click on the errored row to know more info.</span>
                    </v-flex>
                    <v-flex xs4 v-if="totRecs">
                      <v-progress-circular color="primary"
                      :value="readyForLoad ? 100 : (recsLoaded.length/totRecs*100)"
                      :size="50" :width="7">
                      {{ readyForLoad ? totValid : recsLoaded.length }}
                    </v-progress-circular>
                    <br/><div class="caption grey--text">Records</div>
                  </v-flex>
                  <v-flex xs4 v-if="totRecs">
                    <v-progress-circular color="success"
                    :value="(totValid/totRecs*100)"
                    :size="50" :width="7">
                    {{ readyForLoad ? totLoaded : totValid }}
                  </v-progress-circular>
                  <br/><div class="caption grey--text">{{ readyForLoad ? 'Loaded' : 'Valid' }}</div>
                </v-flex>
                <v-flex xs4 v-if="totRecs">
                  <v-progress-circular color="error"
                  :value="(totInvalid/totRecs*100)"
                  :size="50" :width="7">
                  {{ readyForLoad ? totFail : totInvalid }}
                </v-progress-circular>
                <br/><div class="caption grey--text">{{ readyForLoad ? 'Failed' : 'Invalid' }}</div>
              </v-flex>
              <v-flex xs12>
                <v-btn small @click.native="lAction='upload'">Cancel</v-btn>
                <v-btn v-if="totValid > 0" small class="accent" @click.native="uploadResidents" :disabled="beingSaved">Process the valid records</v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 class="mt-2">
            <v-data-table
            :headers="$vuetify.breakpoint.smAndUp?loadHeadSm:loadHead"
            :items="recsLoaded"
            hide-actions
            class="elevation-3 text-xs-left"
            disable-initial-sort
            >
            <template slot="items" slot-scope="props">
              <tr :class="(props.item.error ? (props.item.load_status === 'Failed' ? 'error':'error--text') : (props.item.load_status === 'Loaded' ? 'success' : ''))" @click="props.item.error ? showError(props.item.error) : ''">
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.block_nm }}</td>
                <td>{{ props.item.unit_no }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.bhk }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.acc_sqft }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.ownership }}</td>
                <td>{{ props.item.cust_name }}</td>
                <td>{{ props.item.contact_phone }}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.contact_email}}</td>
                <td v-if="$vuetify.breakpoint.smAndUp">{{ props.item.gender }}</td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-actions class="pt-0" v-if="false">
      <v-spacer></v-spacer>
      <v-btn flat @click.native="cancelChanges">Cancel</v-btn>
    </v-card-actions>
  </v-card>
</v-flex>
</v-layout>
</v-container>

<v-btn v-if="config.IS_USER_EMPOWERED && lAction === 'view'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; right:15px;':'bottom:15px; right:15px;')"
dark fab fixed
color="accent"
@click.native="prepareCreate">
<v-icon>add</v-icon>
</v-btn>

<v-btn v-if="config.IS_USER_EMPOWERED && lAction === 'view'"
:style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:15px; left:15px;':'bottom:15px; left:315px;')"
dark fab fixed small
color="accent"
@click.native="prepareUpload">
<v-icon>file_upload</v-icon>
</v-btn>

<!-- end of screen specific -->

<!-- common elements for alert & loading spinner -->
<v-snackbar :color="sbarCol" v-model="sbar" :timeout="4000" multi-line>
  <span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>

<div v-if="load" style="position:absolute; top:20%; left:50%">
  <v-progress-circular indeterminate color="primary"></v-progress-circular>
</div>

</v-flex>
</v-layout>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'
import VDownloadAs from './VDownloadAs.vue'
import { VueTelInputVuetify } from 'vue-tel-input-vuetify'

export default {
  props: ['action'],
  components:
  {
    'v-download-as': VDownloadAs,
    'vue-tel-input-vuetify': VueTelInputVuetify
  },
  data () {
    return {
      // common
      temp: [],
      lAction: '',
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      load: false,
      handy: handy,
      rules: handy.rules,
      config: config,
      beingSaved: false,
      // screen specific
      mobileNo: '',
      residents: [],
      units: [],
      blocks: [],
      blockList: [],
      unitList: [],
      roles: [],
      resRolesList: [],
      mcRolesList: [],
      totUnits: 0,
      totUsers: 0,
      unitsWithNOUsers: [],
      lResident: '',
      unitHead: [
        { text: 'Block & Unit', value: 'block_and_unit' },
        { text: 'Name', value: 'cust_name' }
      ],
      unitHeadSm: [
        { text: 'Block & Unit', value: 'block_and_unit' },
        { text: 'Name', value: 'cust_name' },
        { text: 'Ownership', value: 'ownership' },
        { text: 'Extn', value: 'int_extn' },
        { text: 'Mobile', value: 'contact_phone_view' },
        { text: 'E-Mail', value: 'contact_email_view' }
      ],
      isViewed: false,
      search: '',
      // file upload
      validateInProgress: true,
      readyForLoad: false,
      loadInProgress: true,
      validFile: true,
      headerIssue: false,
      fileError: false,
      totRecs: 0,
      recsLoaded: [],
      totValid: 0,
      totInvalid: 0,
      totLoaded: 0,
      totFail: 0,
      reqHeaders: ['Block or Street Name', 'House No.', 'BHK', 'Sq Ft', 'Ownership', 'Resident Name', 'Mobile No.', 'E-Mail ID', 'Gender'],
      colNames: [
        {col_name: 'block_nm', is_required: true},
        {col_name: 'unit_no', is_required: true},
        {col_name: 'bhk', is_required: false},
        {col_name: 'acc_sqft', is_required: false},
        {col_name: 'ownership', is_required: false},
        {col_name: 'cust_name', is_required: false},
        {col_name: 'contact_phone', is_required: false},
        {col_name: 'contact_email', is_required: false},
        {col_name: 'gender', is_required: false}
      ],
      loadHead: [
        { text: 'Unit', value: 'unit_no' },
        { text: 'Name', value: 'cust_name' },
        { text: 'Mobile', value: 'contact_phone' }
      ],
      loadHeadSm: [
        { text: 'Block', value: 'block_nm' },
        { text: 'Unit', value: 'unit_no' },
        { text: 'BHK', value: 'bhk' },
        { text: 'Sq Ft', value: 'acc_sqft' },
        { text: 'Ownership', value: 'ownership' },
        { text: 'Name', value: 'cust_name' },
        { text: 'Mobile', value: 'contact_phone' },
        { text: 'E-Mail', value: 'contact_email' },
        { text: 'Gender', value: 'gender' }
      ],
      pagination: { rowsPerPage: 25 },
      filterBy: '',
      isValidNumber: true
    }
  }, // data
  mounted () {
    this.loadResidents()
    this.loadStats()
    this.loadRoles()
    this.lAction = 'view'
  },
  methods: {
    // common methods
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loading () {
      this.load = true
      setTimeout(() => {
        this.load = false
      }, 2000)
    },
    getEmptyUnit () {
      var unit = {
        'comm_id': config.COMM_ID,
        'comm_name': config.COMM_NAME,
        'cust_name': '',
        'block_id': '',
        'unit_id': '',
        'ownership': 'Owner',
        'rel_status': 'Linked',
        'contact_phone': '',
        'int_extn': '',
        'contact_email': '',
        'emergency_phone': '',
        'gender': '',
        'blood_group': '',
        'occupation': '',
        'hobbies': '',
        'hide_contact': true,
        'reg_mode': 'WEB',
        'is_self_service': false
      }
      return unit
    },
    // screen specific methods
    loadResidents () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getResidentsByCommId/', qry)
      .then(response => {
        this.residents = response.data
        // mark units with no users
        console.log(this.residents)
        this.axios.get(config.API_URL + '/getUnitsWithNoUsers/', qry)
        .then(response => {
          this.unitsWithNOUsers = response.data
          this.residents.forEach(rec => {
            rec.is_orphan_unit = this.unitsWithNOUsers.findIndex(orec => orec.unit_id === rec.unit_id) >= 0
          })
        })
        console.log(this.residents)
      })
      .catch(err => {
        this.msg(err.response.data)
        this.residents = []
      })
    },
    loadStats () {
      var qry = {
        params: {
          user_id: config.USER_ID,
          comm_id: config.COMM_ID
        }
      }
      this.loadBlocks()
      this.axios.get(config.API_URL + '/getTotalUnitsByCommId/', qry)
      .then(response => {
        this.totUnits = response.data[0].tot_unit
      })
      .catch(err => {
        this.msg(err.response.data)
      })
      this.axios.get(config.API_URL + '/getTotalUsersByCommId/', qry)
      .then(response => {
        this.totUsers = response.data[0].tot_user
      })
      .catch(err => {
        this.msg(err.response.data)
      })
    },
    ignoreBackspace (e) {
      if (e.key === 'Backspace') {
        const start = this.mobileNo.length - 1
        this.mobileNo = this.mobileNo.substring(0, start)
        e.preventDefault()
      }
    },
    keepCursor () {
      this.$refs.refMob.cursorPosition = this.mobileNo.length
    },
    validateMob ({ number, valid, country }) {
      this.isValidNumber = valid
      if (valid) {
        this.mobileNo = number.e164
      }
    },
    prepareCreate () {
      this.lResident = this.getEmptyUnit()
      this.lAction = 'create'
      this.loadBlocks()
    },
    deleteResident () {
      // confirm
      if (confirm('Sure, you want to delete the resident "' + this.lResident.cust_name + '" belongs to ' + this.lResident.block_nm + ',' + this.lResident.unit_no + '?')) {
        // delete
        this.lResident.user_id = config.USER_ID
        this.axios.post(config.API_URL + '/resident/delete', this.lResident)
        .then(response => {
          // update the table
          this.loadResidents()
          this.loadStats()
          this.beingSaved = false
          this.isViewed = false
        })
        .catch((err) => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }
    },
    prepareUpdate (curUnit) {
      this.lResident = Object.assign({}, curUnit) // keep the original object safely before changes
      this.lResident.old_unit_id = curUnit.unit_id
      this.lResident.res_user_id = curUnit.user_id
      if (this.lResident.contact_phone) {
        this.mobileNo = this.lResident.contact_phone
      }
      // fill in empty instead of null for units with no customer to trigger form validation
      this.lResident.cust_name = this.lResident.cust_name || ''
      this.lResident.gender = this.lResident.gender || ''
      this.lResident.contact_email = this.lResident.contact_email || ''
      this.lResident.ownership = this.lResident.ownership || 'Owner'
      this.isViewed = false
      this.lAction = 'update'
      this.loadBlocks()
    },
    showUnit (curUnit) {
      this.lResident = Object.assign({}, curUnit) // keep the original object safely before changes
      this.isViewed = true
    },
    prepareUpload () {
      this.lAction = 'upload'
    },
    promptUpload () {
      this.$refs.ipFile.click()
    },
    validateFile () {
      this.lAction = 'validate'

      this.validateInProgress = true
      this.loadInProgress = true
      this.validFile = true
      this.headerIssue = false
      this.fileError = false
      this.totRecs = 0
      this.recsLoaded = []
      this.totValid = 0
      this.totInvalid = 0
      this.totLoaded = 0
      this.totFail = 0

      // read file
      var file = this.$refs.ipFile.files[0]

      var reader = new FileReader()
      reader.onload = (e) => {
        var content = e.target.result

        // validate & show result
        var allLines = content.split(/\r\n|\n/)
        this.totRecs = allLines.length - 1
        var headers = allLines[0].split(',')
        // 1. header & required columns
        for (var i = 0; i < this.reqHeaders.length; i++) {
          if (headers[i] !== this.reqHeaders[i]) {
            this.validateInProgress = false
            this.validFile = false
            this.headerIssue = true
            return
          }
        }
        // 2. validate each record
        var res = {}
        var curRec = []
        for (var j = 1; j < allLines.length; j++) {
          if (allLines[j]) {
            curRec = allLines[j].split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/)
            if (curRec[0] !== '' && curRec[1] !== '') { // ignore empty line
              res = {'error': ''}
              for (var c = 0; c < this.colNames.length; c++) {
                if (this.colNames[c].is_required && curRec[c].trim() === '') {
                  res['error'] += this.reqHeaders[c] + ' is empty; '
                } else {
                  res[this.colNames[c].col_name] = curRec[c] && curRec[c].indexOf('"') >= 0 ? curRec[c].split('"').join('') : curRec[c]
                }
              }
              this.recsLoaded.push(res)
              if (res['error']) {
                this.totInvalid++
              } else {
                this.totValid++
              }
            }
          }
        }
        if (this.totInvalid) {
          this.validFile = false
        }
        this.validateInProgress = false
      }
      reader.readAsText(file)

      /* .catch(err => {
      this.fileError = 'Error reading file: ' + err
      this.validateInProgress = false */
    },
    showError (err) {
      this.msg(err, 2)
    },
    async uploadResidents () {
      // create resident records one by one
      this.readyForLoad = true
      this.loadInProgress = true
      this.beingSaved = true
      var curRec = ''

      // pre-processing
      var countryCode = config.COMM_COUNTRY_CODE
      var productURL = config.SUPPORTED_COUNTRIES.find(rec => rec.country_code === config.COMM_COUNTRY_CODE).product_url
      var supportEmail = config.SUPPORTED_COUNTRIES.find(rec => rec.country_code === config.COMM_COUNTRY_CODE).support_email

      for (var i = 0; i < this.recsLoaded.length; i++) {
        curRec = this.recsLoaded[i]
        if (!this.recsLoaded[i].error) { // process only valid records
          // fill-in gaps
          this.recsLoaded[i].comm_id = config.COMM_ID
          this.recsLoaded[i].user_id = config.USER_ID
          this.recsLoaded[i].comm_name = config.COMM_NAME
          this.recsLoaded[i].rel_status = 'Linked'
          this.recsLoaded[i].hide_contact = true
          this.recsLoaded[i].reg_mode = 'APP'
          this.recsLoaded[i].is_self_service = false
          this.recsLoaded[i].country_code = countryCode
          this.recsLoaded[i].product_url = productURL
          this.recsLoaded[i].support_email = supportEmail

          // create record
          await this.axios.post(config.API_URL + '/resident/create', this.recsLoaded[i])
          .then(response => {
            curRec.load_status = 'Loaded'
            this.totLoaded++
            this.$forceUpdate()
          })
          .catch(err => {
            curRec.error = err.response.data
            curRec.load_status = 'Failed'
            this.totFail++
            this.$forceUpdate()
          })
        }
      } // for every record
      this.loadResidents()
      this.loadInProgress = false
      this.beingSaved = false
      this.$forceUpdate()
      if (!this.totFail) {
        this.lAction = 'view'
      }
    },
    saveChanges () {
      // save changes after validation
      if (!this.$refs.lForm.validate()) {
        return
      }
      if (!this.isValidNumber) {
        this.msg('Invalid mobile number')
        return
      }
      if (!this.lResident.block_nm) {
        this.msg('Enter block number')
        return
      }
      this.beingSaved = true
      this.findBlockId()
      this.findUnitId()
      setTimeout(() => {
        // pre logic
        if (this.lResident.old_unit_id === this.lResident.unit_id) {
          this.lResident.old_unit_id = null
        }
        if (!this.lResident.is_mc_member) { // MC member access removed
          this.lResident.role_id = this.resRolesList.find(rec => rec.role_name === this.lResident.ownership).role_id
        } // else MC member access given, keep the chosen role

        // pre-processing
        this.lResident.user_id = config.USER_ID
        this.lResident.reg_mode = this.lResident.reg_mode || 'APP'
        this.lResident.rel_status = this.lResident.rel_status || 'Linked'
        this.lResident.contact_phone = this.mobileNo.replace(/ /g, '')
        this.lResident.country_code = config.COMM_COUNTRY_CODE
        this.lResident.product_url = config.SUPPORTED_COUNTRIES.find(rec => rec.country_code === config.COMM_COUNTRY_CODE).product_url
        this.lResident.support_email = config.SUPPORTED_COUNTRIES.find(rec => rec.country_code === config.COMM_COUNTRY_CODE).support_email

        // save after a time out to find unit id incase user clicks on save without coming out of unit field
        this.axios.post(config.API_URL + '/resident/' + this.lAction, this.lResident)
        .then(response => {
          // update the table
          this.lResident.contact_phone_view = this.lResident.contact_phone
          this.lResident.contact_email_view = this.lResident.contact_email
          this.loadResidents()
          this.loadStats()
          this.lAction = 'view'
          this.beingSaved = false
        })
        .catch((err) => {
          this.msg(err.response.data)
          this.beingSaved = false
        })
      }, 100)
    },
    cancelChanges () {
      this.lAction = 'view'
    },
    loadBlocks () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getBlocksByCommId/', qry)
      .then(response => {
        this.blocks = response.data
        this.blockList = this.blocks.map(rec => rec.block_nm)
        if (this.lResident.block_id) {
          this.loadUnits()
        } else {
          this.unitList = []
        }
      })
      .catch(err => {
        this.msg(err.response.data)
        this.blocks = []
        this.blockList = []
      })
    },
    loadUnits () {
      var qry = {
        params: {
          block_id: this.lResident.block_id
        }
      }
      this.axios.get(config.API_URL + '/getUnitsByBlockId/', qry)
      .then(response => {
        this.units = response.data
        this.unitList = this.units.map(rec => rec.unit_no)
      })
      .catch(err => {
        this.msg(err.response.data)
        this.unitList = []
      })
    },
    loadRoles () {
      var qry = {
        params: {
          comm_id: config.COMM_ID
        }
      }
      this.axios.get(config.API_URL + '/getRolesByCommId/', qry)
      .then(response => {
        this.roles = response.data
        this.resRolesList = this.roles.filter(rec => (rec.role_type === 'Resident'))
        this.mcRolesList = this.roles.filter(rec => (rec.role_type === 'RWA' && rec.role_name !== 'Administrator'))
      })
      .catch(err => {
        this.roles = []
        this.resRolesList = []
        this.mcRolesList = []
        this.msg(err.response.data)
      })
    },
    findBlockId () {
      var idx = this.blocks.findIndex(rec => rec.block_nm === this.lResident.block_nm)
      if (idx >= 0) {
        this.lResident.block_id = this.blocks[idx].block_id
        this.loadUnits()
      } else {
        this.lResident.block_id = ''
        this.unitList = []
        this.msg('Entered block is not found, it will be created newly', 2)
      }
    },
    findUnitId () {
      var idx = this.units.findIndex(rec => rec.unit_no === this.lResident.unit_no)
      if (idx >= 0) {
        this.lResident.unit_id = this.units[idx].unit_id
      } else {
        this.lResident.unit_id = ''
        this.msg('Entered unit is not found, it will be created newly', 2)
      }
    },
    filterList (filter) {
      if (this.filterBy === filter) {
        this.filterBy = '' // clear filter
      } else {
        this.filterBy = filter
      }
    }
  } // methods
} // export
</script>



// WEBPACK FOOTER //
// Residents.vue?b4b8d252